import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import MenuList from './MenuList'

const Menu = () => (
  <StaticQuery
    query={graphql`
      query MenuQuery {
        allPostsJson(sort: { fields: sport, order: ASC }) {
          edges {
            node {
              id
              sport
              competition
            }
          }
        }
      }
    `}
    render={data => (
      <>
        <MenuList items={data.allPostsJson.edges} />
      </>
    )}
  />
)

// sort: { fields: [frontmatter___date], order: DESC }
export default Menu
